<template>
  <SliderRoot
    as-child
    :min="min"
    :max="max"
    :step="step"
    :model-value="modelValue ? [modelValue] : undefined"
    @update:model-value="modelValue = $event![0]"
  >
    <Box
      class="relative flex h-8 touch-none select-none items-center rounded-md bg-white p-1"
      rounded="unset"
    >
      <SliderTrack ref="track" class="relative h-full w-full">
        <SliderRange class="absolute h-full overflow-hidden rounded">
          <div
            :style="{ '--width': `${width}px` }"
            class="flex h-full w-[--width] gap-0.5"
          >
            <div v-for="i in 10" :key="i" class="h-full flex-1 bg-[#00E96B]" />
          </div>
        </SliderRange>
      </SliderTrack>
      <SliderThumb as-child :aria-label="label">
        <Box
          :style="{ '--campaign-color': colors[campaignId] }"
          class="flex h-[36px] w-[45px] bg-[--campaign-color]"
        >
        </Box>
      </SliderThumb>
    </Box>
  </SliderRoot>
</template>

<script setup lang="ts">
import { colors, type Campaign } from "~/lib/campaigns";

withDefaults(
  defineProps<{
    label: string;
    campaignId: Campaign;
    min?: number;
    max?: number;
    step?: number;
    formatValue?: (value: number) => string;
  }>(),
  {
    min: 1,
    max: 30,
    step: 1,
    formatValue: undefined,
  },
);
const modelValue = defineModel<number>();

const track = ref<HTMLElement | null>(null);
const { width } = useElementSize(track);
</script>
